module.exports = __webpack_public_path__ + "img/disk.ea372fe2.png";